// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"500ae0c9","452":"e97a39ab","453":"c1fe9f38","548":"ae18a3a6","734":"96caade1","899":"20d620c7","979":"51ec6227"}[chunkId] + ".chunk.js";
};